import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import React from 'react';
import { MenuLink as ReachMenuLink } from '@reach/menu-button';
import MenuItem from '../utils/MenuItem/MenuItem';
export var DropdownLink = /*#__PURE__*/React.forwardRef(function DropdownLink(_ref, ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "disabled"]);

  return /*#__PURE__*/React.createElement(ReachMenuLink, _extends({
    disabled: disabled,
    ref: ref
  }, rest), /*#__PURE__*/React.createElement(MenuItem, {
    disabled: disabled
  }, children));
});
export default DropdownLink;